export default __webpack_public_path__ + "static/media/highwayracer3dicon.860ec801.jpeg";